// Mapping of colors to icon file paths for parking, bicycle, and locker types

export interface IconMapping {
  color: string;
  name: string;
  parkingIcon: string;
  bicycleIcon: string;
  lockerIcon: string;
}

export const COLOR_ICON_MAP: IconMapping[] = [
  {
    color: '#000000',
    name: 'Black',
    parkingIcon: '/parking-icons/black-single-car.png',
    bicycleIcon: '/bicycle-icons/black-bicycle-parking.png',
    lockerIcon: '/locker-icons/black-single-locker.png'
  },
  {
    color: '#0000FF',
    name: 'Blue',
    parkingIcon: '/parking-icons/blue-single-car.png',
    bicycleIcon: '/bicycle-icons/blue-bicycle-parking.png',
    lockerIcon: '/locker-icons/blue-single-locker.png'
  },
  {
    color: '#00BFFF',
    name: 'Light Blue',
    parkingIcon: '/parking-icons/light-blue-single-car.png',
    bicycleIcon: '/bicycle-icons/light-blue-bicycle-parking.png',
    lockerIcon: '/locker-icons/light-blue-single-locker.png'
  },
  {
    color: '#00FFFF',
    name: 'Mint',
    parkingIcon: '/parking-icons/mint-single-car.png',
    bicycleIcon: '/bicycle-icons/mint-bicycle-parking.png',
    lockerIcon: '/locker-icons/mint-single-locker.png'
  },
  {
    color: '#00FF00',
    name: 'Green',
    parkingIcon: '/parking-icons/green-single-car.png',
    bicycleIcon: '/bicycle-icons/green-bicycle-parking.png',
    lockerIcon: '/locker-icons/green-single-locker.png'
  },
  {
    color: '#FFA500',
    name: 'Orange',
    parkingIcon: '/parking-icons/orange-single-car.png',
    bicycleIcon: '/bicycle-icons/orange-bicycle-parking.png',
    lockerIcon: '/locker-icons/orange-single-locker.png'
  },
  {
    color: '#FF00FF',
    name: 'Pink',
    parkingIcon: '/parking-icons/pink-single-car.png',
    bicycleIcon: '/bicycle-icons/pink-bicycle-parking.png',
    lockerIcon: '/locker-icons/pink-single-locker.png'
  },
  {
    color: '#800080',
    name: 'Purple',
    parkingIcon: '/parking-icons/purple-single-car.png',
    bicycleIcon: '/bicycle-icons/purple-bicycle-parking.png',
    lockerIcon: '/locker-icons/purple-single-locker.png'
  },
  {
    color: '#FF0000',
    name: 'Red',
    parkingIcon: '/parking-icons/red-single-car.png',
    bicycleIcon: '/bicycle-icons/red-bicycle-parking.png',
    lockerIcon: '/locker-icons/red-single-locker.png'
  },
  {
    color: '#FFD700',
    name: 'Yellow',
    parkingIcon: '/parking-icons/yellow-single-car.png',
    bicycleIcon: '/bicycle-icons/yellow-bicycle-parking.png',
    lockerIcon: '/locker-icons/yellow-single-locker.png'
  }
];

/**
 * Get the parking icon path for a given color
 */
export function getParkingIconByColor(color: string): string | null {
  const mapping = COLOR_ICON_MAP.find(m => m.color.toLowerCase() === color.toLowerCase());
  return mapping ? mapping.parkingIcon : null;
}

/**
 * Get the bicycle icon path for a given color
 */
export function getBicycleIconByColor(color: string): string | null {
  const mapping = COLOR_ICON_MAP.find(m => m.color.toLowerCase() === color.toLowerCase());
  return mapping ? mapping.bicycleIcon : null;
}

/**
 * Get the locker icon path for a given color
 */
export function getLockerIconByColor(color: string): string | null {
  const mapping = COLOR_ICON_MAP.find(m => m.color.toLowerCase() === color.toLowerCase());
  return mapping ? mapping.lockerIcon : null;
}

/**
 * Get icon path for any type based on color and type
 */
export function getIconByColorAndType(color: string, type: 'parking' | 'bicycle' | 'locker'): string | null {
  switch (type) {
    case 'parking':
      return getParkingIconByColor(color);
    case 'bicycle':
      return getBicycleIconByColor(color);
    case 'locker':
      return getLockerIconByColor(color);
    default:
      return null;
  }
}
